import * as React from "react";

// https://stackoverflow.com/a/42234988
export const useOutsideAlerter = <T extends HTMLElement, >(ref: React.MutableRefObject<T | null>, onOutsideClick: () => void) => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
        if (ref?.current && !ref?.current?.contains(event.target)) {
            onOutsideClick();
        }
    }

    React.useEffect(() => {
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
};


// WEBPACK FOOTER //
// ./src/components/hooks/useOutsideAlerter.tsx